import { Controller } from "stimulus"
import * as $ from "jquery"

type ToastValue = string | number | boolean | string[] | null

export default class ToastController extends Controller {
  static targets = ["toast", "message", "undoButton"]

  readonly toastTarget!: HTMLElement
  readonly hasToastTarget!: boolean
  readonly messageTarget!: HTMLElement
  readonly hasMessageTarget!: boolean
  readonly undoButtonTarget!: HTMLElement
  readonly hasUndoButtonTarget!: boolean

  private undoUrl: string | null = null
  private undoField: string | null = null
  private undoValue: ToastValue = null
  private undoParams: Record<string, string> = {}

  connect(): void {}

  show(event?: CustomEvent): void {
    if (!this.hasToastTarget) return

    if (event && event.detail) {
      if (event.detail.message && this.hasMessageTarget) {
        this.messageTarget.textContent = event.detail.message
      }

      this.toastTarget.classList.toggle("bg-success-light", !event.detail.error)
      this.toastTarget.classList.toggle("border-success", !event.detail.error)
      this.toastTarget.classList.toggle("bg-danger-light", !!event.detail.error)
      this.toastTarget.classList.toggle("border-danger", !!event.detail.error)

      if (!event.detail.error && event.detail.undoUrl && event.detail.undoField !== undefined && event.detail.undoValue !== undefined) {
        this.undoUrl = event.detail.undoUrl
        this.undoField = event.detail.undoField
        this.undoValue = event.detail.undoValue
        this.undoParams = event.detail.undoParams || {}

        if (this.hasUndoButtonTarget) this.undoButtonTarget.style.display = "block"
      } else {
        this.undoUrl = null
        this.undoField = null
        this.undoValue = null
        this.undoParams = {}

        if (this.hasUndoButtonTarget) this.undoButtonTarget.style.display = "none"
      }
    }

    ($(this.toastTarget) as any).toast("show")
  }

  hide(): void {
    if (this.hasToastTarget) {
      ($(this.toastTarget) as any).toast("hide")
    }
  }

  undo(): void {
    if (!this.undoUrl || this.undoField === null || this.undoValue === null) {
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

    fetch(this.undoUrl, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken || "",
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        field: this.undoField,
        value: this.undoValue,
        ...this.undoParams
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.hide()
          this.revertFieldValue()
        } else {
          console.error("Failed to undo:", data.message)
        }
      })
      .catch(error => {
        console.error("Error undoing change:", error)
      })
  }

  private revertFieldValue(): void {
    const checkbox = document.querySelector(`input[type="checkbox"][name*="${this.undoField}"]`) as HTMLInputElement
    if (checkbox) {
      checkbox.checked = this.undoValue === true
      return
    }

    const radio = document.querySelector(`input[type="radio"][name*="${this.undoField}"][value="${this.undoValue}"]`) as HTMLInputElement
    if (radio) {
      radio.checked = true
      return
    }

    const select = document.querySelector(`select[name*="${this.undoField}"]`) as HTMLSelectElement
    if (select) {
      if (select.multiple) {
        const values = Array.isArray(this.undoValue) ? this.undoValue : []
        Array.from(select.options).forEach(option => {
          option.selected = values.includes(option.value)
        })
        select.dataset.previousValue = JSON.stringify(values)
      } else {
        const value = String(this.undoValue)
        select.value = value
        select.dataset.previousValue = value
      }
      this.refreshSelectpicker(select)
      return
    }

    const textarea = document.querySelector(`textarea[name*="${this.undoField}"]`) as HTMLTextAreaElement
    if (textarea) {
      const value = String(this.undoValue)
      textarea.value = value
      textarea.dataset.previousValue = value
      // A summernote editor renders from its own DOM, so the textarea alone would
      // leave the visible text unchanged.
      if ($(textarea).data("summernote")) ($(textarea) as any).summernote("code", value)
      return
    }

    const input = document.querySelector(`input[name*="${this.undoField}"]`) as HTMLInputElement
    if (input) {
      const value = String(this.undoValue)
      input.value = value
      input.dataset.previousValue = value
    }
  }

  private refreshSelectpicker(select: HTMLSelectElement): void {
    if (select.classList.contains("selectpickerr")) {
      ($(select) as any).selectpicker("refresh")
    }
  }
}
